import config from "../_config/config";
import { deleteCookie, deleteTokens, getReferer, getToken, setTokens } from "../_helpers/cookies";
import { getErrorCode, getErrorMsg } from "../_helpers/errors";
import axios from "../_helpers/interceptor";

export const userService = {
  login,
  logout,
  register,
  fgtpasswd
};

function login(username, password, isRegisteredUser, vendor) {
  const url = new URL(window.location.href);
  const requestOptions = {
    method: "POST",
    url: vendor ? `${config.algoendpoint}${config.algoauth}` : `${config.endpoint}${config.auth}`,
    data: {
      username,
      password,
      isRegisteredUser,
      clientId: "tbsenterpriseweb",
      appId: "1",
      ogReferer: getReferer(),
      ...(vendor? {
            vendorName: url.searchParams.get("vendor") || "",
            state: url.searchParams.get("state") || "",
            redirectURL: url.searchParams.get("referer") || "",
          } : {}),
    }
  };

  /*return fetch(`${config.apiUrl}/user/signin`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });*/

  return (
    axios(requestOptions)
      /* .then(handleResponse) */
      .then(user => {
        if(vendor) {
          const { data: { success, error } } = user
          if(error) {
            return Promise.reject(user)
          } else {
            return success
          }
        } else {
          user = user.data.success;
          // const { access_token, refresh_token } = user;
          if(isRegisteredUser) {
            const { access_token, refresh_token } = user;
            deleteTokens();
            setTokens(access_token, refresh_token);
          }
          localStorage.setItem("access_token", JSON.stringify(user));
          // deleteTokens();
          // setTokens(access_token, refresh_token);
          return user;
        }
        // user = user.data.success;
        // setReferer();

        // const { access_token, refresh_token, isTradingClient, isFirstLogin } = user;
        // localStorage.setItem("access_token", JSON.stringify(user));
        // setCookie("token", access_token);
        // setCookie("refresh_token", refresh_token);

        // deleteTokens();
        // setTokens(access_token, refresh_token);

        // document.cookie = "token=" + access_token + ";path=/"; //domain=tradebulls.in
        // document.cookie = "refresh_token=" + refresh_token + ";path=/"; //domain=tradebulls.in
        // login successful if there's a jwt token in the response
        // if (access_token && !isTradingClient && !isFirstLogin) {//Block only for registered users
        //   console.log('Block only for registered users');
        //   // store user details and jwt token in local storage to keep user logged in between page refreshes
        //   // let referer = window.location.href.split("?referer=")[1];
        //   let referer = getReferer();
        //   window.location.href = (referer && atob(referer)) || config.contentendpoint;
        //   return;
        //   return null;
        // }
        //if not continue the login & 2FA stuff
        // return success;
        // return { ...user, isFirstLogin: true };
        // return { ...user, isPasswordExpired: true };
      })
      .catch(function (error) {
        // console.log("userService");
        // Object.keys(error).map(key => {
        //   console.log(key, error[key]);
        // });
        // let errorMessage = error.message && error.message.includes("401")
        //   ? "Invalid Login Credentials" : "Oops! Something went wrong!";
        let errorMessage = "Oops! Something went wrong!";
        if (error && error.data && error.data.error &&
          (error.data.error.error_description || error.data.error.errorDesc || error.data.error.errordesc)) {
          errorMessage = error.data.error.error_description || error.data.error.errorDesc || error.data.error.errordesc;
        }
        // return Promise.reject(errorMessage);
        return Promise.reject({ errorCode: getErrorCode(error), error: getErrorMsg(error) });
      })
  );
}

function logout() {
  const requestOptions = {
    method: "POST",
    url: `${config.endpoint}${config.signout}`,
    // data: { username, password, clientId: "tbsenterpriseweb", appId: "1" }
  };

  axios(requestOptions)
    .then(response => {
      console.log("Signout response", response);
      console.log("Access Token", getToken(true));
      // console.log('userService.logout');
      // remove user from local storage to log user out
      localStorage.removeItem("access_token");
      deleteCookie("token");
      deleteTokens();
    }).catch(error => {
      console.log("Signout error", JSON.stringify(error));
      deleteTokens();
    });
}

function register(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/users/register`, requestOptions).then(
    handleResponse
  );
}
function fgtpasswd(userid) {
  const requestOptions = {
    method: "POST",
    url: `${config.endpoint}${config.auth}`,
    data: { userid, clientId: "tbsenterpriseweb" }
  };
}

function handleResponse(response) {
  console.log(response);

  const data = response.data;

  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    //location.reload(true);
  }

  return data;
}
